import { AccountChangesParams } from 'app/pages/admin/customers/components/accountChanges/types';

export const accountChangesKeys = {
  get: (params: AccountChangesParams) => ['ACCOUNT_CHANGES', params] as const,
};
